<span id="{{ renderMode }}">
  <div class="ac">
    <input
      class="ac-input"
      [ngStyle]="{ width: inputWidth, 'min-width': minWidth }"
      [ngClass]="valid ? '' : 'ac-input-invalid'"
      type="text"
      [placeholder]="placeholder"
      [value]="selectedValue"
      [attr.title]="selectedValue"
      [tabIndex]="focusInputOnLoad ? 0 : null"
      [disabled]="disabled"
      (input)="input($event)"
      (click)="click($event)"
      (keydown)="keydown($event)"
      (keyup)="keyup($event)"
      (blur)="blur($event)"
      (focus)="focus($event)"
      #searchInput
      #searchBox
      />
      @if (searching || dataLoading) {
        <div class="loading-spinner spinner-border spinner-border-sm"></div>
      }
      @if (!searching && !dataLoading && !disabled) {
        <mat-icon
          [fontIcon]="searchInput.value ? 'close' : 'search'"
          class="clear-icon"
          [ngStyle]="{ left: 'calc(' + inputWidth + ' - 30px)' }"
          (click)="clearInput(searchInput, true)"
          [matTooltip]="searchInput.value ? 'Clear' : ''"
          matTooltipShowDelay="500"
          #clearSearch
        ></mat-icon>
      }
      <div
        #dropDownContainer
        class="ac-dropdown-container"
        [ngClass]="embeddedDropDown ? 'embedded' : ''"
        [class.expand-up]="expandUp"
        [class.anchor]="position === 'fixed'"
        [style.position]="position"
        [style.maxHeight]="maxHeight"
        [ngStyle]="items.length === 0 || hide ? { display: 'none' } : { display: 'block' }"
        >
        @for (item of items$ | async; track $index; let i = $index) {
          <div
            class="ac-item"
            [ngClass]="i === highlightItemIndex ? 'ac-highlight' : ''"
            (click)="select(item)"
            (mouseenter)="onItemHover(i)"
            [matTooltip]="itemTooltip(item)"
            matTooltipShowDelay="500"
            >
            <div class="truncate">
              @if (item.icon) {
                @if (item.iconUrl) {
                  <app-salesforce-entity-icon
                    [iconUrl]="item.iconUrl"
                    [iconColor]="item.iconColor"
                    [iconClass]="item.icon"
                    [tooltip]="itemIconTooltip(item) ? (itemIconTooltip(item) | titlecase) + ' entity' : ''"
                    imgClass="ac-entity-icon">
                  </app-salesforce-entity-icon>
                } @else {
                  <i
                    class="{{ item.icon }}"
                    [matTooltip]="itemIconTooltip(item) ? (itemIconTooltip(item) | titlecase) + ' entity' : ''"
                    matTooltipShowDelay="500"
                  ></i>
                }
              }
              {{ item.label }}
              @if (item.details) {
                <span class="additional-details">{{ item.details }}</span>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </span>
